.skip {
  position: fixed;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 200;
  padding: 0.7rem 1.1rem;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--on-accent);
  font-size: var(--step--1);
  font-weight: 600;
  text-decoration: none;
  box-shadow: var(--shadow-md);

  /* Off-screen until focused, but never display:none so it stays focusable. */
  transform: translateY(-150%);
  transition: transform 150ms ease-out;
}

.skip:focus-visible {
  transform: translateY(0);
  color: var(--on-accent);
  outline: 2px solid var(--text);
  outline-offset: 2px;
}
